import type { DisciplineProgressReportsStore } from './interfaces'

export const getters = {
  isLoading: (state: DisciplineProgressReportsStore): DisciplineProgressReportsStore['loading'] => state.loading,
  getReports: (state: DisciplineProgressReportsStore): DisciplineProgressReportsStore['reports'] => state.reports,
  hasReports: (state: DisciplineProgressReportsStore): boolean => state.reports.length > 0,
  getMeta: (state: DisciplineProgressReportsStore): DisciplineProgressReportsStore['meta'] => state.meta,
  getFilters: (state: DisciplineProgressReportsStore): DisciplineProgressReportsStore['filters'] => state.filters,
  getCurrentPage: (state: DisciplineProgressReportsStore): DisciplineProgressReportsStore['currentPage'] => state.currentPage,
  getPerPage: (state: DisciplineProgressReportsStore): DisciplineProgressReportsStore['perPage'] => state.perPage,
  getEditingReport: (state: DisciplineProgressReportsStore): DisciplineProgressReportsStore['editingReport'] => state.editingReport,
}
